<template>
  <div class="spinner-container">
    <div
      :style="inlineStyle"
      class="spinner"
    />
  </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 36,
    },
  },
  setup(props) {
    const inlineStyle = `width: ${props.size}px; height: ${props.size}px`

    return {
      inlineStyle,
    }
  },
})
</script>

<style lang="scss" scoped>
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--spl-primary);
  // width: 48px;
  // height: 48px;
  @apply rounded-full;

  animation: spin 1s linear infinite;
}

.spinner-container {
  @apply my-4;
  @apply flex justify-center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
